// extracted by mini-css-extract-plugin
export default {"price":"a2-z","onSale":"b2-z","msrpLabelPrice":"c2-z","msrpLabel":"d2-z","originalPrice":"e2-z","percentOff":"f2-z"};